import {
  Box,
  List,
  ListItemButton,
  ListItemContent,
  ListItemDecorator,
  Typography,
} from "@mui/joy";
import { DoneTaskType, HistoryType } from "api/dashboardApi";
import Calender from "./Calender";
import { useEffect, useState } from "react";
import useOpenTask from "hooks/useOpenTask";
import CustomCard from "components/common/CustomCard";
import useGetTaskTitleFromTaskKey from "hooks/useGetTaskTitleFromTaskKey";

function TaskListItem({ taskKey }: { taskKey: string }) {
  const openTask = useOpenTask(`${taskKey}`);
  const title = useGetTaskTitleFromTaskKey(taskKey);
  return (
    <CustomCard>
      <ListItemButton
        sx={{
          height: "fit-content",
          color: "text.positive",
        }}
        onClick={openTask}
      >
        <ListItemContent sx={{ color: "text.primary" }}>
          <Typography level={"body-sm"}>{title}</Typography>
        </ListItemContent>
        <ListItemDecorator
          sx={{
            "--ListItemDecorator-size": "20px",
            opacity: 0.4,
            fontSize: "1rem",
          }}
        >
          <span
            style={{ fontSize: "inherit" }}
            className="material-symbols-rounded"
          >
            north_east
          </span>
        </ListItemDecorator>
      </ListItemButton>
    </CustomCard>
  );
}

export default function History({ listByDate }: HistoryType) {
  const [selectedDate, setSelectedDate] = useState<string | undefined>(
    undefined
  );

  const [doneTaskList, setDoneTaskList] = useState<DoneTaskType[] | undefined>(
    undefined
  );

  useEffect(() => {
    if (selectedDate && listByDate) {
      setDoneTaskList(
        listByDate.find((element) => element.date === selectedDate)
          ?.doneTaskList
      );
    }
  }, [listByDate, selectedDate]);

  return (
    <CustomCard sx={{ height: "100%", width: "100%" }}>
      <Box sx={{ width: "100%", px: 1, pb: 2, overflow: "hidden" }}>
        <Calender setSelectedDate={setSelectedDate} />
        <List aria-labelledby="basic-list-demo" sx={{ px: "7px", gap: 1 }}>
          {doneTaskList?.map(({ taskKey }) => (
            <TaskListItem key={`doneTaskByDate${taskKey}`} taskKey={taskKey} />
          ))}
        </List>
      </Box>
    </CustomCard>
  );
}
